import { useEffect, useRef, useState } from 'react';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { useDispatch } from "react-redux";
import { isEqual, isUndefined } from "lodash";

import reduxUtil from "@plannel/utils/redux-util";

const CustomDetailHeader = props => {
  const reduxDispatch = useDispatch();
  const { viewName, displayName, detailColumns, colsHide, reduxKey, columnApi, api, column } = props;

  const [visible, setVisible] = useState(isUndefined(colsHide) ? true : colsHide);
  const colsHideReduxKey = reduxKey ? reduxKey : "colsHide";

  const orders = [null, 'asc', 'desc'];
  const currentOrderIdx = useRef(0);

  const showDetail = event => {
    event.stopPropagation();

    (columnApi ?? api).setColumnsVisible(detailColumns, visible);
    setVisible(!visible);
  }

  useEffect(() => {
    const reduxState = reduxUtil.createObjectState(viewName, { [colsHideReduxKey]: visible });
    reduxDispatch(reduxUtil.updateViewState(reduxState));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const onSortRequested = event => {
    const nextOrderIdx = (currentOrderIdx.current + 1) % 3;
    currentOrderIdx.current = nextOrderIdx;

    props.setSort(orders[nextOrderIdx], event.shiftKey);
  };

  const getSortIcon = order => {
    if (isEqual(order, "asc") || (isEqual(order, "desc"))) {
      return (
        <Box className='ag-sort-indicator-container' component="span">
          <Box className={`ag-sort-indicator-icon ag-sort-${order}ending-icon`}>
            <Box className={`ag-icon ag-icon-${order}`} component="span" />
          </Box>
        </Box>
      );
    }

    return "";
  }

  const HideComponent = () => {
    if (visible) {
      return <ArrowForwardIosIcon color="primary" sx={{ fontSize: "14px" }} />
    }
    return <ArrowBackIosIcon color="error" sx={{ fontSize: "14px" }} />
  }

  return (
    <Box className="ag-cell-label-container" role="presentation">
      <Box className="ag-header-cell-label" onClick={onSortRequested}>
        <Box className='ag-header-cell-text' component="span">{displayName}</Box>
        {getSortIcon(column.sort)}
        <IconButton aria-label="collapsed" size="small" onClick={showDetail} sx={{ ml: 1 }}>
          <HideComponent/>
        </IconButton>
      </Box>
    </Box>
  );
};

export default CustomDetailHeader;